exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-455ffab3]{border:none!important;padding:0}.modal fade show d-block[data-v-455ffab3]{background:none}[data-v-455ffab3]{margin-bottom:0;margin-left:0;margin-right:0;padding-left:2px;padding-right:2px;padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-455ffab3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/leadDashboard.vue
// module id = 1548
// module chunks = 0